module.exports = __webpack_public_path__ + "static/media/bbc_co_uk_news_uk-england-36550304_plot.1cd56218.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_co_uk_news_uk-england-36550304_plot.png
// module id = 343
// module chunks = 0